import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import DynamicDTFloat from "../DynamicDTFloat";
import DropDownControl from "../DropDownControl";

import BrandedLoader from "../BrandedLoader";
import { hst03_report_json_format, generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, goFullScreen } from "../../utils";
import DropDownCustom from "./../DropDownCustom";

import ProcessLoader from "../ProcessLoader";


const SM02 = () => {

    const navigate = useNavigate();

    const div_data = JSON.parse(localStorage.getItem('div_data'));
    console.log(div_data['data'][0]['value']);
    const year_data = JSON.parse(localStorage.getItem('year_data'));
    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data'));
    const seleted_div_value = div_data['data'][0]['value'];
    const [showOptions, setShowOptions] = useState(true);
    const [reportGenData, setreportGenData] = useState({});
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedYear, setSelectedYear] = useState(year_data.data[0].value);
    const [SelectedDepo, setSelectedDepo] = useState(0);
    const [SelectedStartMonth, setSelectedStartMonth] = useState(month_data.data[0].value);
    const [SelectedEndMonth, setSelectedEndMonth] = useState(month_data.data[month_data.index - 1].value);
    const [UnitValue, setUnitvalue] = useState(1);
     const [UnitAllHQ, setUnitAllHQ] = useState(0);
    const [ReportType, setReportType] = useState(10);
    const [ReportOption, setReportOption] = useState(1);
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [showAllHQ, setShowAllHQ] = useState(true);
    const [pageTitle, setPageTitle] = useState('');
    const [productlistLoading, setProductlistLoading] = useState(true);
    const [productListItems, setProductListItems] = useState([]);
    const [SelectedGroup, setSelectedGroup] = useState(0);
    const [OptnValue, setOptnValue] = useState(0);



    const reportOptionList = [
        { "name": "Gross Sale", "value": 1 },
        { "name": "Saleable", "value": 2 },
        { "name": "Expiry", "value": 3 },
        { "name": "Breakage", "value": 4 },
        { "name": "Net Sale", "value": 5 },
        // {"name":"Budget", "value": 6},
        // {"name":"Lys Sales", "value": 7},
        // {"name":"Ach.", "value": 8},
        // {"name":"Gth.", "value": 9},
        // {"name":"PMR", "value": 10},
        // {"name":"PI Sale", "value": 11},
        { "name": "Gross + Free", "value": 12 }
    ]

    function convertProductData(dataAPIResponse) {
        if (dataAPIResponse && Array.isArray(dataAPIResponse.data)) {
            const converted_list = dataAPIResponse.data.map(item => ({
                value: item['value'],
                label: item['name']
            }));
            return converted_list;
        }
        return [];
    }

    const handleExportSheet = async () => {

        var reportJson = {};
        reportJson.fileName = reportGenData.title + ".xlsx";
        reportJson.title = reportGenData.title;
        reportJson.author = "Aristo Pharma";

        reportJson.sheets = [
            {
                name: "Sheet 1",
                data: []
            }
        ]

        const columns = Object.keys(reportGenData.data[0]).filter(key => key !== 'color');
        const headerFormatted = columns.map(key => getHeaderColNames(key));

        reportJson.sheets[0].data.push({
            backgroundColor: "#0043a9",
            fontColor: "#FFFFFF",
            fontSize: 13,
            bold: true,
            values: headerFormatted
        });

        const backgroundColors = excelColorCodes;

        reportGenData.data.forEach(item => {
            const row = {
                backgroundColor: backgroundColors[item.color] || "",
                fontColor: item.color === 2 ? "#333333" : "#333333",
                fontSize: 12,
                bold: false,
                values: columns.map(col => item[col])
            };
            reportJson.sheets[0].data.push(row);
        });

        generateExcel(reportJson).catch(console.error);

    }

    const getSampleProducts = async (divID) => {

        try {
            const response = await proxy(`/api/mis/sampleproductlist/${divID}`, {}, "get");


            setProductListItems(response.data);
            setSelectedGroup(response.data[0].value);
            setProductlistLoading(false);


        } catch (error) {
            console.error("Error fetching sample products:", error);
            return [];// Return an empty array or handle the error as needed
        }
    };


    const handleReportGen = async () => {

        setShowProcessLoader(true);
        document.getElementById('btnReportGen').innerHTML = "PROCESSING...";
        goFullScreen();
        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),
            "smon": parseInt(SelectedStartMonth),
            "emon": parseInt(SelectedEndMonth),
            "code": parseInt(SelectedGroup),
            "uv": parseInt(UnitValue),
            "rep_type": parseInt(UnitAllHQ),
            "optn" : parseInt(OptnValue)
         
            
        }
        var reportAPIResponse = {};
        reportAPIResponse = await proxy(`/api/mis/samplesm02`, payload, "post");

        if (reportAPIResponse.data.length > 0) {
            const new_data = hst03_report_json_format(reportAPIResponse);
            setreportGenData(new_data);
            setShowProcessLoader(false);
            setShowOptions(false);
        }

    }

    const handleBranchChange = async (newValue) => {
        setSelectedDepo(newValue);

      
        if (newValue == 0) {
            setShowAllHQ(true);
        }else{
            setShowAllHQ(false);
            setUnitAllHQ(0);
        }

    }


    const handleProductChange = (selectedGroup) => {
        if (selectedGroup.length > 20) {
            alert('Maximum of 20 products can be selected at a time. Please remove extra products.');
        } else {
            setSelectedGroup(selectedGroup);
        }
    }

    useEffect(() => {
        transformNavDataForLabels("SM02").then(title => {
            setPageTitle(title);
        });

      
        getSampleProducts(SelectedDiv);


    }, []);

    return (
        <>
            <div class="main-content">
                {showProcessLoader && <ProcessLoader />}
                {showOptions ?
                    <ReportOptions title={pageTitle} >
                        <div className="report-option-wrapper">
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label>Division</label>
                                    <DropDownControl selectedValue={SelectedDiv} data={div_data.data} id="report_div_list" name="report_div_list" onChange={(newVal) => { setSelectedDIV(newVal); setProductlistLoading(true); getSampleProducts(newVal) }} />
                                </div>

                                <div className="report-option-item ml-20" >
                                    <label>Branch</label>
                                    <DropDownControl data={depo_data.data} id="report_branch_list" name="report_branch_list"

                                        onChange={handleBranchChange}
                                    />
                                </div>

                            </div>

                            <div className="report-option-row">
                                 <div className="report-option-item ml-10">
                                    <label>Mkt&nbsp;Year</label>
                                    <DropDownControl data={year_data.data} id="report_mktyear_list" name="report_mktyear_list" onChange={(newYear) => { console.log(newYear); setSelectedYear(newYear) }} />

                                </div>
                                
                                <div className="report-option-item">
                                    <label>From</label>
                                    <DropDownControl data={month_data.data} id="report_startyear_list" name="report_startyear_list" selectedValue={SelectedStartMonth} onChange={(val) => { console.log(val); setSelectedStartMonth(val) }} />
                                </div>
                                <div className="report-option-item ml-10">
                                    <label>To</label>
                                    <DropDownControl data={month_data.data} id="report_endyear_list" name="report_endyear_list" selectedValue={SelectedEndMonth} onChange={(val) => { console.log(val); setSelectedEndMonth(val) }} />
                                </div>
                               
                            </div>


                            <div className="report-option-row">
                                <div className="report-option-item">

                                    <input type="radio" class="js-switched mr-10" name="report_unitvalue" checked={(true && UnitValue === 1)} onChange={(e) => { setUnitvalue(1); }} />

                                    <label>Unit</label>

                                </div>
                                <div className="report-option-item ml-10">
                                    <input type="radio" class="js-switched mr-10" name="report_unitvalue" checked={(true && UnitValue === 2)} onChange={(e) => { setUnitvalue(2); }} />
                                    <label>Value</label>
                                </div>
                            </div>

                        {showAllHQ && <>
                            <div className="report-option-row" >

                                 <div className="report-option-item">

                                    <input type="checkbox" class="js-switched mr-10" name="report_allhq" checked={(true && UnitAllHQ === 1)} onChange={(e) => { UnitAllHQ ? setUnitAllHQ(0) : setUnitAllHQ(1);  }} />

                                    <label>All HQ</label>

                                </div>
                            </div>
</> }

<div className="report-option-row" >

                                 <div className="report-option-item">

                                    <input type="checkbox" class="js-switched mr-10" name="report_allhq" checked={(true && OptnValue === 1)} onChange={(e) => { OptnValue ? setOptnValue(0) : setOptnValue(1);  }} />

                                    <label>Alloc vs Issue</label>

                                </div>
                            </div>

                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label >Select&nbsp;Product</label>
                                    {productlistLoading ? <BrandedLoader /> :

                                        <DropDownControl selectedValue={SelectedGroup} data={productListItems} id="report_prod_list" name="report_prod_list" onChange={(newVal) => { setSelectedGroup(newVal); }} />
                                    }

                                </div>
                            </div>


                            <div className="report-option-action-row">
                                <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                                <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SUBMIT</button>
                            </div>
                        </div>
                    </ReportOptions>
                    :
                    <>
                        <div className="row">
                            <div className="col-12">
                                <div className="card report-card" style={{ width: "auto" }}>
                                    <div className="card-title report-card-title">{reportGenData.title}
                                        <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                                    </div>
                                    <div className="card-body">
                                        <DynamicDTFloat
                                            tableData={reportGenData}
                                            handleExportSheet={handleExportSheet}
                                            fixedColumns={true}
                                            forceDecimal={reportGenData.decimal_keys?.length > 0}
                                            decimalKeys={reportGenData.decimal_keys}
                                        />

                                    </div>
                                    <div className="card-footer">

                                        <button className="btn btn-outline btn-primary text-white btn-sm float-right"
                                            onClick={handleExportSheet}
                                        >Export Excel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }


            </div>
        </>

    );
}

export default SM02;


